/*
 * GDP 11/10/2026 · PANIER v2 (refonte du tiroir, thème de travail).
 * Rail de suggestions : barre de défilement fine sous le rail, comme le menu (snippets/gdp-pv2-rail.liquid).
 * Aucune autre écoute : les ajouts du rail passent par le formulaire standard (data-gdp-upsell-form) déjà géré par le bus
 * window.GDPCart (snippets/gdp-cart-event-fix.liquid). Version allégée du 11/10 : la montée en abonnement est retirée du tiroir.
 */
(function () {
  if (window.__gdpPv2Installed) return;
  window.__gdpPv2Installed = true;

  function drawer() { return document.querySelector('cart-drawer'); }

  // ---------------------------------------------------------------- Rail : barre de défilement fine
  function paintRail(list) {
    var rail = list.closest('[data-gdp-pv2-rail]');
    var thumb = rail && rail.querySelector('.gdp-pv2-rail__thumb');
    if (!thumb) return;
    var max = list.scrollWidth - list.clientWidth;
    var ratio = list.scrollWidth > 0 ? Math.min(1, list.clientWidth / list.scrollWidth) : 1;
    var pos = max > 0 ? list.scrollLeft / max : 0;
    thumb.style.width = (ratio * 100).toFixed(2) + '%';
    thumb.style.transform = 'translateX(' + (pos * (1 / ratio - 1) * 100).toFixed(2) + '%)';
    rail.classList.toggle('is-static', max <= 2);
  }
  function paintAll() {
    var d = drawer();
    if (!d) return;
    Array.prototype.forEach.call(d.querySelectorAll('.gdp-pv2-rail__list'), paintRail);
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('gdp-pv2-rail__list')) paintRail(t);
  }, true);

  // Bande des suggestions bord à bord : la marge du tiroir (20 px sur mobile, 32 px sur ordinateur) est lue sur la partie « body »
  // du tiroir (shadow DOM) et posée en variable CSS (--pv2-bleed) ; repli à 20 px dans la feuille.
  function setBleed() {
    var d = drawer();
    var body = d && d.shadowRoot && d.shadowRoot.querySelector('[part~="body"]');
    if (!body) return;
    var pad = getComputedStyle(body).paddingLeft;
    if (pad && d.style.getPropertyValue('--pv2-bleed') !== pad) d.style.setProperty('--pv2-bleed', pad);
  }

  function watch() {
    var d = drawer();
    if (!d || d.__gdpPv2Obs) return;
    d.__gdpPv2Obs = new MutationObserver(function () { requestAnimationFrame(function () { setBleed(); paintAll(); }); });
    d.__gdpPv2Obs.observe(d, { childList: true, attributes: true, attributeFilter: ['open'] });
    setBleed();
    paintAll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  window.addEventListener('resize', function () { requestAnimationFrame(function () { setBleed(); paintAll(); }); });
})();
